import ActivateDefaultResponse from 'actions/composition/activate_default_response';
import { getActiveConversationId } from 'actions/conversation/lib/conversation_helpers';
import Snippet, { SnippetChannel, SnippetChannels, SnippetContent } from 'models/answers/snippet';
import SelectedKbItem from 'models/selected_kb_item';

export default function insertIntoComposer(context, customerStores, html) {
  const { currentCompositionId } = context.stores.currentLocation.get();

  if (!currentCompositionId) {
    const conversationId = getActiveConversationId(customerStores.conversations);
    if (conversationId) {
      context.executeAction(ActivateDefaultResponse, { conversationId });
    }
  }

  context.stores.selectedKbItem.set(toSelectedKbItem(html));
}

// The composer reads the reply the way it reads a chosen Answer, so the reply
// rides in a throwaway Snippet.
function toSelectedKbItem(html) {
  const snippetChannels = SnippetChannels.create({
    anyChannel: SnippetContent.create({ bodyHtml: html }),
    language: 'en-us',
  });

  return SelectedKbItem.create({
    item: Snippet.create({ name: 'Team Assist Response', contents: [snippetChannels] }),
    channelType: SnippetChannel.ANY_CHANNEL,
    language: 'en-us',
  });
}
